/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ExportsRouteImport } from './routes/exports'
import { Route as CatalogRouteImport } from './routes/catalog'
import { Route as AdminRouteRouteImport } from './routes/_admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ReportsIdRouteImport } from './routes/reports.$id'
import { Route as DashboardsIdRouteImport } from './routes/dashboards.$id'
import { Route as AdminTenantTemplatesRouteImport } from './routes/_admin/tenant-templates'
import { Route as AdminTemplatesRouteImport } from './routes/_admin/templates'
import { Route as AdminRolesRouteImport } from './routes/_admin/roles'
import { Route as AdminGrantsRouteImport } from './routes/_admin/grants'
import { Route as AdminAuditLogRouteImport } from './routes/_admin/audit-log'
import { Route as AdminAdminRouteImport } from './routes/_admin/admin'

const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportsRoute = ExportsRouteImport.update({
  id: '/exports',
  path: '/exports',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogRoute = CatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsIdRoute = ReportsIdRouteImport.update({
  id: '/reports/$id',
  path: '/reports/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardsIdRoute = DashboardsIdRouteImport.update({
  id: '/dashboards/$id',
  path: '/dashboards/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTenantTemplatesRoute = AdminTenantTemplatesRouteImport.update({
  id: '/tenant-templates',
  path: '/tenant-templates',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminTemplatesRoute = AdminTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminRolesRoute = AdminRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminGrantsRoute = AdminGrantsRouteImport.update({
  id: '/grants',
  path: '/grants',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAuditLogRoute = AdminAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAdminRoute = AdminAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AdminRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/catalog': typeof CatalogRoute
  '/exports': typeof ExportsRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/admin': typeof AdminAdminRoute
  '/audit-log': typeof AdminAuditLogRoute
  '/grants': typeof AdminGrantsRoute
  '/roles': typeof AdminRolesRoute
  '/templates': typeof AdminTemplatesRoute
  '/tenant-templates': typeof AdminTenantTemplatesRoute
  '/dashboards/$id': typeof DashboardsIdRoute
  '/reports/$id': typeof ReportsIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/catalog': typeof CatalogRoute
  '/exports': typeof ExportsRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/admin': typeof AdminAdminRoute
  '/audit-log': typeof AdminAuditLogRoute
  '/grants': typeof AdminGrantsRoute
  '/roles': typeof AdminRolesRoute
  '/templates': typeof AdminTemplatesRoute
  '/tenant-templates': typeof AdminTenantTemplatesRoute
  '/dashboards/$id': typeof DashboardsIdRoute
  '/reports/$id': typeof ReportsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_admin': typeof AdminRouteRouteWithChildren
  '/catalog': typeof CatalogRoute
  '/exports': typeof ExportsRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/_admin/admin': typeof AdminAdminRoute
  '/_admin/audit-log': typeof AdminAuditLogRoute
  '/_admin/grants': typeof AdminGrantsRoute
  '/_admin/roles': typeof AdminRolesRoute
  '/_admin/templates': typeof AdminTemplatesRoute
  '/_admin/tenant-templates': typeof AdminTenantTemplatesRoute
  '/dashboards/$id': typeof DashboardsIdRoute
  '/reports/$id': typeof ReportsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/catalog'
    | '/exports'
    | '/login'
    | '/logout'
    | '/admin'
    | '/audit-log'
    | '/grants'
    | '/roles'
    | '/templates'
    | '/tenant-templates'
    | '/dashboards/$id'
    | '/reports/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/catalog'
    | '/exports'
    | '/login'
    | '/logout'
    | '/admin'
    | '/audit-log'
    | '/grants'
    | '/roles'
    | '/templates'
    | '/tenant-templates'
    | '/dashboards/$id'
    | '/reports/$id'
  id:
    | '__root__'
    | '/'
    | '/_admin'
    | '/catalog'
    | '/exports'
    | '/login'
    | '/logout'
    | '/_admin/admin'
    | '/_admin/audit-log'
    | '/_admin/grants'
    | '/_admin/roles'
    | '/_admin/templates'
    | '/_admin/tenant-templates'
    | '/dashboards/$id'
    | '/reports/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  CatalogRoute: typeof CatalogRoute
  ExportsRoute: typeof ExportsRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  DashboardsIdRoute: typeof DashboardsIdRoute
  ReportsIdRoute: typeof ReportsIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exports': {
      id: '/exports'
      path: '/exports'
      fullPath: '/exports'
      preLoaderRoute: typeof ExportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog': {
      id: '/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof CatalogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/$id': {
      id: '/reports/$id'
      path: '/reports/$id'
      fullPath: '/reports/$id'
      preLoaderRoute: typeof ReportsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboards/$id': {
      id: '/dashboards/$id'
      path: '/dashboards/$id'
      fullPath: '/dashboards/$id'
      preLoaderRoute: typeof DashboardsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/tenant-templates': {
      id: '/_admin/tenant-templates'
      path: '/tenant-templates'
      fullPath: '/tenant-templates'
      preLoaderRoute: typeof AdminTenantTemplatesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_admin/templates': {
      id: '/_admin/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof AdminTemplatesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_admin/roles': {
      id: '/_admin/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof AdminRolesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_admin/grants': {
      id: '/_admin/grants'
      path: '/grants'
      fullPath: '/grants'
      preLoaderRoute: typeof AdminGrantsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_admin/audit-log': {
      id: '/_admin/audit-log'
      path: '/audit-log'
      fullPath: '/audit-log'
      preLoaderRoute: typeof AdminAuditLogRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_admin/admin': {
      id: '/_admin/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminAdminRouteImport
      parentRoute: typeof AdminRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminAdminRoute: typeof AdminAdminRoute
  AdminAuditLogRoute: typeof AdminAuditLogRoute
  AdminGrantsRoute: typeof AdminGrantsRoute
  AdminRolesRoute: typeof AdminRolesRoute
  AdminTemplatesRoute: typeof AdminTemplatesRoute
  AdminTenantTemplatesRoute: typeof AdminTenantTemplatesRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminAdminRoute: AdminAdminRoute,
  AdminAuditLogRoute: AdminAuditLogRoute,
  AdminGrantsRoute: AdminGrantsRoute,
  AdminRolesRoute: AdminRolesRoute,
  AdminTemplatesRoute: AdminTemplatesRoute,
  AdminTenantTemplatesRoute: AdminTenantTemplatesRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  CatalogRoute: CatalogRoute,
  ExportsRoute: ExportsRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  DashboardsIdRoute: DashboardsIdRoute,
  ReportsIdRoute: ReportsIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
